import { Injectable } from '@angular/core';
import { HelperService} from './helper.service';
import { BnLoadingService } from '@bndes/bndes-angular-utils';
import { LoggerService } from './logger.service';
import { AcessoExternoService } from './acesso.externo.service';
import { BnAlertsService } from '@bndes/bndes-ux4';
import { ErrorHandlerService } from './error-handler.service';
import { SessionStorageService } from './session-storage.service';


@Injectable()
export class Services {
  constructor (
    public acessoExternoService: AcessoExternoService,
    public sessionStorageService: SessionStorageService,
    public helperService: HelperService,
    public loadingService: BnLoadingService,
    public logger: LoggerService,
    public bnAlertService: BnAlertsService,
    public errorHandlerService: ErrorHandlerService
  ) { }
}

export const SERVICES_CONST = [
    Services,
    AcessoExternoService,
    SessionStorageService,
    HelperService,
    BnLoadingService,
    ErrorHandlerService,
    BnAlertsService
];
